<template>
    <div>

      <LessonsListFilter @search-courses="fetchCourses" @search-teachers="fetchTeachers" />

      <BCard no-body class="mb-0">
        <div class="m-2">
          <BRow>

            <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>

            <BCol cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  /> -->
                <BButton variant="primary" :to="{ name: 'lessons-add' }" v-if="ability.can('create', 'lesson')"> <span class="text-nowrap">{{$t('Add lesson')}}</span> </BButton>
              </div>
            </BCol>

          </BRow>
        </div>

        <!-- Table -->
        <BTable ref="refDataListTable" class="position-relative" :items="fetchData" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">

          <template #cell(datetime)="data">
            <small>
                <span class="text-nowrap text-center"><b>{{ formatDate(data.item.start_date)}}</b></span><br>
                <BLink :to="{ name: 'lessons-view', params: { id: data.item.id} }"><span class="text-nowrap text-center">{{ data.item.start_time }} - {{ data.item.end_time }}</span></BLink>
            </small>
          </template>

          <template #cell(course)="data" v-if="ability.can('read', 'course')">
            <BLink :to="{ name: 'courses-view', params: { id: data.item.course.id} }">{{ data.item.course.name }} <br> </BLink>
          </template>

          <template #cell(course)="data" v-else>
            <span> {{ data.item.course.name }} <br> </span>
          </template>

          <template #cell(teacher)="data" v-if="ability.can('read', 'teacher')">
            <BLink v-if="data.item.teacher" :to="{ name: 'teachers-view', params: { id: data.item.teacher.id} }" > {{ data.item.teacher.name + " " + data.item.teacher.surname }} <br> </BLink>
            <span v-else>-</span>
          </template>

          <template #cell(teacher)="data" v-else>
            <span> {{ data.item.teacher.name + " " + data.item.teacher.surname }} <br> </span>
          </template>

         
          <template #cell(is_extra)="data">
            <BFormCheckbox id="checkbox-paid" v-model="data.item.is_extra" disabled ></BFormCheckbox> <span v-if="data.item.is_extra"> {{ formatCurrency(data.item.amount) }}</span>
          </template>

          <template #cell(classroom)="data">
            <span v-if="data.item.classroom"> {{ data.item.classroom.name }} <br> </span>
            <span v-else>-</span>
          </template>

          <template #cell(observations)="data">
            <span>{{ data.item.observations ? data.item.observations : '-'  }}</span>
          </template>



          <template #cell(actions)="data">
            <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

              <template #button-content> <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" /> </template>
              <BDropdownItem :to="{ name: 'lessons-view', params: { id: data.item.id } }" v-if="ability.can('read', 'lesson')">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">{{$t('Details')}}</span>
              </BDropdownItem>

              <BDropdownItem :to="{ name: 'lessons-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'lesson')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{$t('Edit')}}</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopupAxios(data.item.id, `lessons/${data.item.id}`)" v-if="ability.can('delete', 'lesson')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{$t('Delete')}}</span>
              </BDropdownItem>

            </BDropdown>
          </template>
        </BTable>

        <!-- Paginate -->
        <div class="mx-2 mb-2">
          <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <BPagination v-model="currentPage" :total-rows="totalData" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text> <feather-icon icon="ChevronLeftIcon" size="18" /> </template>
                <template #next-text> <feather-icon icon="ChevronRightIcon" size="18" /> </template>
              </BPagination>
            </BCol>
          </BRow>
        </div>

      </BCard>
    </div>
  </template>

  <script>
  import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox} from 'bootstrap-vue'
  import {provide } from '@vue/composition-api';
  import LessonsListFilter from './LessonsListFilter.vue';
  import lessonListQuery from './lessonListQuery'
  import ability from '@/libs/acl/ability'
  import popups from '@/hooks/popups'
  import vSelect  from 'vue-select'
  import currency from '@/utils/currency'
  import dateUtils from '@/hooks/dateUtils'


 

  export default {
    components: { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, LessonsListFilter, BFormCheckbox },
    setup(){
      const { fetchData, fetchCourses, fetchTeachers,  tableColumns, perPage, currentPage, totalData, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refDataListTable, refetchData, teachersOptions, teacherFilter, coursesOptions, courseFilter } = lessonListQuery()
      const { deletePopupAxios } = popups()
      const { formatDate } = dateUtils()
      const { formatCurrency } = currency()
      provide('teachers', teachersOptions)
      provide('courses', coursesOptions)
      provide('teacherFilter', teacherFilter)
      provide('courseFilter', courseFilter)

      fetchCourses(null)
      fetchTeachers(null)

      return {
        deletePopupAxios,
        fetchData,
        fetchCourses, 
        fetchTeachers, 
        tableColumns,
        perPage,
        currentPage,
        totalData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refDataListTable,
        refetchData,
        ability,
        formatCurrency,
        formatDate,
      }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
